<template>
    <actions-menu v-model:dialogRetry="dialog" :Id="Id" dialogConsult="ProductPriceList" :dialogConsultUrl="productId"
        :ShowDialogConsult="true" :ShowDialogDelete="false" :ShowDialogEdit="true" dialogEdit="ProductEdit"
        :dialogEditUrl="productId" :ShowDialogStatus="afficheStaus" :status="afficheActive"
        v-model:dialogStatus="dialogStatus" :ValidationStatus="productStatus == 6 ? true : false" :ShowDialogValidation="true"
        dialogValidation="ProductsValidation" :dialogValidationUrl="productId" consultTitle="Price lists" />

    <dialogDelete DialogType="Status" v-model="dialogStatus" :status="afficheActive" :yes="ChangeStatus"
        width="450px" />
    <dialogDelete DialogType="OrderedStatus" v-model="dialogOrderedStatus" :yes="ChangeStatusOrdered" width="450px" />


</template>
<script>
import { ChangeStatusOfProductById, ProductIsOrdered } from "@/api";
import actionsMenu from "@/genericComponent/actionsMenu.vue";
import DialogDelete from "@/genericComponent/dialogDelete.vue";
export default {
    components: { actionsMenu, DialogDelete },
    props: {
        productId: {
            type: String,
            required: true,
        },
        GetProductsAfterDeleted: {},
        Id: {},
        productStatus: {}
    },
    data() {
        return {
            dialog: false,
            dialogStatus: false,
            dialogOrderedStatus: false,
            afficheStaus: this.productStatus === 6 || this.productStatus === 7,
            afficheActive: null,
            IsActive: true,
        };
    },
    created() {
        this.afficheStaus = this.productStatus === 6 || this.productStatus === 7;
        this.afficheActive = this.productStatus === 7 ? null : 'value';
    },
    methods: {
        async ChangeStatus() {
            if (this.afficheActive) {
                const response = await ProductIsOrdered(this.productId);

                if (response.data === false) {
                    ChangeStatusOfProductById(this.productId).then(() => {
                        this.GetProductsAfterDeleted();
                    });
                }
                else {
                    this.dialogStatus = false;
                    this.dialogOrderedStatus = true;
                }
            }
            else {
                ChangeStatusOfProductById(this.productId).then(() => {
                    this.GetProductsAfterDeleted();
                });
            }
        },
        ChangeStatusOrdered() {
            ChangeStatusOfProductById(this.productId).then(() => {
                this.GetProductsAfterDeleted();
            });
        },
        ActiveDeletedSnackBar() {
            this.getParent('MainLayout').ActiveDeletedSnackBar();
        },
        ActiveWarningSnackBar() {
            this.getParent('MainLayout').ActiveWarningSnackBar();
        },
        ActiveSavedSnackBar() {
            this.getParent('MainLayout').ActiveSavedSnackBar();
        },
        getParent(name) {
            let p = this.$parent;
            while (typeof p !== 'undefined') {
                if (p.$options.name == name) {
                    return p;
                } else {
                    p = p.$parent;
                }
            }
            return false;
        },
    },
};
</script>